export default interface GeometryScaling {
    extent: number;
    min: number;
    max: number;
    scale?: number;
}
